"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const d3_1 = require("d3");
const lodash_1 = __importStar(require("lodash"));
const prop_types_1 = __importStar(require("prop-types"));
const react_1 = __importStar(require("react"));
const react_event_injector_1 = require("react-event-injector");
// import { svgPathProperties as SvgPathProperties } from 'svg-path-properties';
const Annotation_1 = __importDefault(require("../../components/Annotation"));
const Axis_1 = __importStar(require("../../components/Axis"));
const EllipsizedLabel_1 = __importDefault(require("../../components/EllipsizedLabel"));
const FilledAreaLine_1 = __importDefault(require("../../components/FilledAreaLine"));
const Footer_1 = require("../../components/Footer");
const Gridlines_1 = __importStar(require("../../components/Gridlines"));
const LabelContainer_1 = __importDefault(require("../../components/LabelContainer"));
const Lines_1 = __importDefault(require("../../components/Lines"));
const Tooltip_1 = __importDefault(require("../../components/Tooltip"));
const TooltipContent_1 = __importDefault(require("../../components/Tooltip/TooltipContent"));
const utilities_1 = require("../../utilities");
const colors_1 = require("../../utilities/colors");
const constants_1 = require("../../utilities/constants");
const date_1 = require("../../utilities/date");
const measurements_1 = require("../../utilities/measurements");
const types_1 = require("../../utilities/types");
const constants_2 = require("./constants");
const helpers_1 = require("./helpers");
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
const AXIS_LABEL_PADDING = 10;
const MOBILE_AXIS_WDTH = 365;
const InnerContent = react_1.default.memo(_ref => {
  let {
    annotationData = [],
    chartHeight,
    chartWidth,
    data = [],
    dataSeriesOptions = [],
    fillToOrigin,
    hoveredLabel,
    isSpark,
    lastTouchPoint,
    lineData = [],
    moveTooltip = () => {},
    onClickLine,
    onMouseOutLine,
    onMouseOverLine,
    onMouseOverTooltip = () => {},
    optsGridLine = {},
    optsLabel = {},
    optsTooltip = {},
    optsXAxis = {},
    optsYAxis = {},
    refittedXdomain,
    scrubStartPoint,
    selectedLines,
    setHoveredLabel = () => {},
    setlastTouchPoint = () => {},
    setLine = () => {},
    setScrubStartPoint = () => {},
    setTooltipToLineEnd = () => {},
    tooltip = {},
    transitionDuration,
    xScale,
    xTicks,
    xType,
    yScale,
    yTicks,
    yType
  } = _ref;
  const [scrubbing, setScrubbing] = (0, react_1.useState)(false);
  const [scrubLineId, setScrubLineId] = (0, react_1.useState)(undefined);
  const oldDomainRanges = (0, react_1.useRef)([]);
  const oldDomain = (0, react_1.useRef)({});
  const verticalScrubberPoint = (0, react_1.useRef)(null);
  const horizontalScrubberPoint = (0, react_1.useRef)(null);
  const showLabels = optsLabel.show || optsLabel.show !== false && chartWidth > constants_2.AUTO_LEGEND_BREAKPOINT;
  const maxLineLabelWidth = showLabels ? (optsLabel.width || Math.min(Math.max(...lineData.map(i => (0, measurements_1.textDimensions)({
    text: i.name
  }).width)), constants_2.LINE_CHART_MAX_LABEL_SIZE)) + constants_1.LINE_CHART_PADDING : 0;
  const xAxisFormat = (0, utilities_1.axisFormatter)({
    dataType: xType,
    isMobile: chartWidth < MOBILE_AXIS_WDTH
  });
  const yAxisFormat = (0, utilities_1.axisFormatter)({
    dataType: yType
  });
  const maxYAxisLabelWidth = Math.max(...yTicks.map(tick => (0, measurements_1.textDimensions)({
    text: yAxisFormat(tick, {
      ticks: yTicks
    }),
    fontSize: optsYAxis.fontSize
  }).width));
  const darkenZeroLine = yTicks.some(tick => tick > 0) && yTicks.some(tick => tick < 0);
  xScale.range([constants_1.LINE_CHART_PADDING + (lodash_1.default.includes(optsYAxis.displayTicks, 'left') ? maxYAxisLabelWidth + AXIS_LABEL_PADDING : 0), chartWidth - constants_1.LINE_CHART_PADDING - (lodash_1.default.includes(optsYAxis.displayTicks, 'right') ? maxYAxisLabelWidth + AXIS_LABEL_PADDING : 0) - maxLineLabelWidth]);
  yScale.range([chartHeight - (lodash_1.default.includes(optsXAxis.displayTicks, 'bottom') ? optsXAxis.fontSize + AXIS_LABEL_PADDING : 0), lodash_1.default.includes(optsXAxis.displayTicks, 'top') ? optsXAxis.fontSize + AXIS_LABEL_PADDING : 0]).nice();
  const delaunays = (0, helpers_1.getDelaunays)((0, helpers_1.getDelaunayData)(lineData, xType), xScale, yScale);
  const shouldFill = fillToOrigin && lineData.length === 1;
  const lineDataIdsString = (0, utilities_1.getDataIds)(lineData);
  const refittedXdomainString = refittedXdomain === null || refittedXdomain === void 0 ? void 0 : refittedXdomain.join();
  const selectedLineIdsString = selectedLines === null || selectedLines === void 0 ? void 0 : selectedLines.join();
  const scaledLines = (0, react_1.useMemo)(() => lineData.map(_ref2 => {
    let {
      color,
      customDomain,
      data,
      endMarker,
      id,
      lineStyle,
      lineWeight,
      markerColor,
      markerWeight
    } = _ref2;
    let opacity = 0.25;
    if (!selectedLines.length || selectedLines.includes(id)) {
      opacity = 1;
    } else if (hoveredLabel === id) {
      opacity = 0.5;
    }
    const unformattedLine = (0, d3_1.line)().x(_ref3 => {
      let {
        x
      } = _ref3;
      return xScale(x);
    }).y(_ref4 => {
      let {
        y
      } = _ref4;
      return yScale(y);
    })(data.filter(_ref5 => {
      let {
        y
      } = _ref5;
      return Number.isFinite(y);
    }));
    const minXBound = customDomain.map(x => xScale(x))[0];
    const maxXBound = customDomain.map(x => xScale(x))[1];
    const em = endMarker ? {
      x: xScale(lodash_1.default.last(data).x),
      y: yScale(lodash_1.default.last(data).y),
      color: lodash_1.default.last(markerColor),
      weight: markerWeight
    } : null;
    /*
    DEPRECATING THIS BECAUSE IT"S UNCLEAR WHY IT"S EVEN NEEDED.
    KEEPING CODE FOR REFERENCE IN CASE IT CREATES NEW BUGS.
    
    const lineSegments = new SvgPathProperties(unformattedLine);
    const visibleSegments = lineSegments
      .getParts()
      .filter(({ start, end }) => start.x >= minXBound && end.x <= maxXBound);
    const visiblePoints = visibleSegments.length && [
      { x: visibleSegments[0].start.x, y: visibleSegments[0].start.y },
      ...visibleSegments.map(({ end }) => ({ x: end.x, y: end.y }))
    ];
    const customClipPath = `M ${Math.min(...visiblePoints.map(({ x }) => x))} ${
      -lineWeight / 2
    } L ${Math.max(...visiblePoints.map(({ x }) => x))} ${-lineWeight / 2} L ${Math.max(
      ...visiblePoints.map(({ x }) => x)
    )} ${chartHeight + lineWeight / 2} L ${Math.min(...visiblePoints.map(({ x }) => x))} ${
      chartHeight + lineWeight / 2
    } Z`;
    const leftCap = `M ${visiblePoints[0].x + lineWeight / 2}, ${
      visiblePoints[0].y - lineWeight / 2
    } m -${lineWeight / 2}, 0 a ${lineWeight / 2},${lineWeight / 2} 0 1,0 0,${lineWeight}`;
    const rightCap = `M ${visiblePoints[visiblePoints.length - 1].x + lineWeight / 2}, ${
      visiblePoints[visiblePoints.length - 1].y + lineWeight / 2
    } m -${lineWeight / 2}, 0 a ${lineWeight / 2},${lineWeight / 2} 0 1,0 0,-${lineWeight}`;
    const clipPath = [customClipPath, leftCap, rightCap].join(' ');
    */
    let durationMultiplier = 1;
    const oldDomainIndex = oldDomainRanges.current.findIndex(_ref6 => {
      let {
        id: oldId
      } = _ref6;
      return id === oldId;
    });
    if (oldDomainIndex !== -1) {
      if (oldDomain.current[0] === refittedXdomain[0] && oldDomain.current[1] === refittedXdomain[1]) {
        durationMultiplier = Math.abs(maxXBound - minXBound - oldDomainRanges.current[oldDomainIndex].range) * 10 / chartWidth;
      }
      oldDomainRanges.current[oldDomainIndex] = {
        id,
        range: maxXBound - minXBound
      };
    } else {
      oldDomainRanges.current.push({
        id,
        range: maxXBound - minXBound
      });
    }
    return {
      cap: shouldFill ? 'butt' : 'round',
      clipPath: '',
      color,
      cursor: isSpark ? 'default' : undefined,
      durationMultiplier,
      endMarker: em,
      id,
      line: unformattedLine,
      opacity,
      style: lineStyle,
      weight: lineWeight
    };
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [chartHeight, chartWidth, hoveredLabel, isSpark, lineDataIdsString, refittedXdomainString, selectedLineIdsString, shouldFill, xScale.length, yScale.length]);
  oldDomain.current = refittedXdomain;
  let scaledLabels = lineData.map(_ref7 => {
    let {
      id,
      name,
      color,
      data,
      fontSize,
      labelText
    } = _ref7;
    let opacity = 0.25;
    if (!selectedLines.length || selectedLines.includes(id)) {
      opacity = 1;
    } else if (hoveredLabel === id) {
      opacity = 0.5;
    }
    return {
      content: labelText === undefined ? name : labelText,
      x: xScale.range()[1] + constants_1.LINE_CHART_PADDING,
      y: yScale(data[data.length - 1].y) + constants_1.FONT_VERTICAL_CENTER_OFFSET_RATIO * fontSize,
      key: id,
      style: {
        opacity,
        fontSize,
        fill: color,
        fontWeight: 600,
        cursor: 'pointer'
      }
    };
  });
  scaledLabels = scaledLabels.map(label => ({
    ...label,
    content: react_1.default.createElement(EllipsizedLabel_1.default, {
      fontSize: label.style.fontSize || constants_1.DEFAULT_FONT_SIZE,
      fontFamily: constants_1.FONT_FAMILY,
      maxWidth: maxLineLabelWidth,
      maxLines: 1,
      dominantBaseline: "auto",
      label: label.content
    })
  }));
  const scaledAnnotations = annotationData.map(_ref8 => {
    let {
      lineId,
      x,
      y,
      ...annotation
    } = _ref8;
    return {
      ...annotation,
      opacity: !selectedLines.length || selectedLines.includes(lineId) ? 1 : 0.25,
      x: xScale(x),
      y: yScale(y)
    };
  });
  try {
    scaledLabels = (0, utilities_1.separateRectangles)(scaledLabels.map(pl => ({
      point: pl.y,
      size: pl.style.fontSize
    })), Math.max(...yScale.range())).map((rect, rectIndex) => {
      const pl = scaledLabels.find((pl, plIndex) => plIndex === rectIndex) || {};
      pl.y = rect.point;
      return pl;
    });
  } catch (err) {
    console.log(err);
  }
  const filteredFirstLineData = lineData[0].data.filter(_ref9 => {
    let {
      x
    } = _ref9;
    if ((0, date_1.isDateType)(xType)) {
      var _lineData$0$customDom, _lineData$0$customDom2, _lineData$0$customDom3, _lineData$0$customDom4, _lineData$0$customDom5, _lineData$0$customDom6;
      const time = x.getTime();
      return time >= (lineData === null || lineData === void 0 ? void 0 : (_lineData$0$customDom = lineData[0].customDomain) === null || _lineData$0$customDom === void 0 ? void 0 : (_lineData$0$customDom2 = _lineData$0$customDom[0]) === null || _lineData$0$customDom2 === void 0 ? void 0 : (_lineData$0$customDom3 = _lineData$0$customDom2.getTime) === null || _lineData$0$customDom3 === void 0 ? void 0 : _lineData$0$customDom3.call(_lineData$0$customDom2)) && time <= (lineData === null || lineData === void 0 ? void 0 : (_lineData$0$customDom4 = lineData[0].customDomain) === null || _lineData$0$customDom4 === void 0 ? void 0 : (_lineData$0$customDom5 = _lineData$0$customDom4[1]) === null || _lineData$0$customDom5 === void 0 ? void 0 : (_lineData$0$customDom6 = _lineData$0$customDom5.getTime) === null || _lineData$0$customDom6 === void 0 ? void 0 : _lineData$0$customDom6.call(_lineData$0$customDom5));
    }
    return x >= lineData[0].customDomain[0] && x <= lineData[0].customDomain[1];
  });
  const contrainedFirstLine = (0, d3_1.line)().x(_ref10 => {
    let {
      x
    } = _ref10;
    return xScale(x);
  }).y(_ref11 => {
    let {
      y
    } = _ref11;
    return yScale(y);
  })(filteredFirstLineData.filter(_ref12 => {
    let {
      y
    } = _ref12;
    return Number.isFinite(y);
  }));
  const setLineFromSVG = (event, delaunays) => {
    if (!scrubbing) {
      const {
        top,
        left
      } = event.currentTarget.getBoundingClientRect();
      const x = event.clientX - left;
      const y = event.clientY - top;
      const point = (0, helpers_1.getHoverPoint)(data, lineData, delaunays, x, y, xScale, yScale);
      if (point && dataSeriesOptions[point.lineNum]) {
        const index = lineData.findIndex(i => i.id === dataSeriesOptions[point.lineNum].id);
        setLine(null, index, dataSeriesOptions[point.lineNum]);
      }
    }
  };
  const updateScrubLineId = (event, delaunays) => {
    if (!scrubbing) {
      const {
        top,
        left
      } = event.currentTarget.getBoundingClientRect();
      const x = event.touches[0].clientX - left;
      const y = event.touches[0].clientY - top;
      const point = (0, helpers_1.getHoverPoint)(data, lineData, delaunays, x, y, xScale, yScale);
      if (point && dataSeriesOptions[point.lineNum]) {
        setScrubLineId([point.line.id]);
      }
    }
    return undefined;
  };
  const setPreventDefault = event => {
    if (scrubbing === null) {
      const touch = event.touches[0];
      setScrubbing(Math.abs(touch.pageX - scrubStartPoint.pageX) > Math.abs(touch.pageY - scrubStartPoint.pageY));
    }
  };
  const clearScrubbingLinePoints = () => {
    verticalScrubberPoint.current = null;
    horizontalScrubberPoint.current = null;
  };
  const setScrubbingLinePoints = event => {
    const {
      top,
      left
    } = event.currentTarget.getBoundingClientRect();
    let {
      clientX,
      clientY
    } = event;
    if (event.touches && event.touches.length) {
      clientX = event.touches[0].clientX;
      clientY = event.touches[0].clientY;
    }
    const x = clientX - left;
    const y = clientY - top;
    if (optsGridLine.showVerticalScrubber) {
      if ((0, utilities_1.isBetween)(x, ...lodash_1.default.sortBy(xScale.range()))) {
        verticalScrubberPoint.current = clientX - left;
      }
    } else {
      verticalScrubberPoint.current = null;
    }
    if (optsGridLine.showHorizontalScrubber) {
      if ((0, utilities_1.isBetween)(y, ...lodash_1.default.sortBy(yScale.range()))) {
        horizontalScrubberPoint.current = clientY - top;
      }
    } else {
      horizontalScrubberPoint.current = null;
    }
  };
  const lineMouseOver = (0, react_1.useCallback)((event, i) => {
    const {
      top,
      left
    } = event.nativeEvent.path[3].getBoundingClientRect();
    setHoveredLabel(lineData[i] ? lineData[i].id : undefined);
    if (lastTouchPoint === undefined) {
      onMouseOverTooltip(event, top, left, delaunays, undefined, lineData[i] ? lineData[i].id : undefined);
    }
    if (typeof onMouseOverLine === 'function') {
      onMouseOverLine(event, i, {
        key: tooltip.key,
        value: tooltip.value
      });
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [delaunays.x, lastTouchPoint, lineDataIdsString, onMouseOverTooltip, setHoveredLabel, onMouseOverLine, tooltip.value]);
  const lineMouseMove = (0, lodash_1.throttle)((event, i) => {
    const {
      top,
      left
    } = event.nativeEvent.path[3].getBoundingClientRect();
    setHoveredLabel(lineData[i] ? lineData[i].id : undefined);
    if (lastTouchPoint === undefined) {
      onMouseOverTooltip(event, top, left, delaunays, undefined, lineData[i] ? lineData[i].id : undefined);
    }
  });
  const lineMouseOut = (0, react_1.useCallback)((e, i) => {
    setHoveredLabel(undefined);
    if (typeof onMouseOutLine === 'function') {
      onMouseOutLine(e, i, {
        key: tooltip.key,
        value: tooltip.value
      });
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [setHoveredLabel, onMouseOutLine, tooltip.value]);
  const lineMouseClick = (0, react_1.useCallback)((e, i) => {
    e.stopPropagation();
    setLine(e, i);
    if (typeof onClickLine === 'function') {
      onClickLine(e, i, {
        key: tooltip.key,
        value: tooltip.value
      });
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [tooltip.value]);
  const compareLineData = (lineArray1, lineArray2) => {
    if (lineArray1.length !== lineArray2.length) {
      return false;
    }
    return lineArray1.every((line1, i) => {
      const {
        cap: line1Cap = '',
        clipPath: line1ClipPath = '',
        color: line1Color = '',
        cursor: line1Cursor = '',
        durationMultiplier: line1Multiplier = '',
        id: line1Id = '',
        line: line1Line = '',
        opacity: line1Opacity = '',
        style: line1Style = '',
        weight: line1Weight = ''
      } = line1 || {};
      const {
        cap: line2Cap = '',
        clipPath: line2ClipPath = '',
        color: line2Color = '',
        cursor: line2Cursor = '',
        durationMultiplier: line2Multiplier = '',
        id: line2Id = '',
        line: line2Line = '',
        opacity: line2Opacity = '',
        style: line2Style = '',
        weight: line2Weight = ''
      } = lineArray2[i] || {};
      return line1Cap === line2Cap && line1ClipPath === line2ClipPath && line1Color === line2Color && line1Cursor === line2Cursor && line1Id === line2Id && line1Line === line2Line && line1Multiplier === line2Multiplier && line1Opacity === line2Opacity && line1Style === line2Style && line1Weight === line2Weight;
    });
  };
  const currentLines = (0, react_1.useRef)(scaledLines.map(_ref13 => {
    let {
      cap,
      clipPath,
      color,
      cursor,
      durationMultiplier,
      endMarker,
      id,
      line,
      opacity,
      style,
      weight
    } = _ref13;
    return {
      cap,
      clipPath,
      color,
      cursor,
      durationMultiplier,
      endMarker,
      id,
      line,
      opacity,
      style,
      weight
    };
  }));
  if (!compareLineData(scaledLines, currentLines.current)) {
    currentLines.current = scaledLines.map(_ref14 => {
      let {
        cap,
        clipPath,
        color,
        cursor,
        durationMultiplier,
        endMarker,
        id,
        line,
        opacity,
        style,
        weight
      } = _ref14;
      return {
        cap,
        clipPath,
        color,
        cursor,
        durationMultiplier,
        endMarker,
        id,
        line,
        opacity,
        style,
        weight
      };
    });
  }
  return react_1.default.createElement("div", {
    style: {
      display: 'flex',
      flex: 1,
      height: '100%'
    }
  }, react_1.default.createElement(react_event_injector_1.EventInjector, {
    onTouchMove: event => {
      const {
        top,
        left
      } = event.currentTarget.getBoundingClientRect();
      setPreventDefault(event);
      if (scrubbing) {
        onMouseOverTooltip(event, top, left, delaunays, undefined, scrubLineId);
        setScrubbingLinePoints(event);
      }
      if (scrubbing || optsGridLine.showHorizontalScrubber || optsGridLine.showVerticalScrubber) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    settings: {
      passive: false
    }
  }, react_1.default.createElement("svg", {
    style: {
      overflow: 'visible',
      flex: 1,
      height: chartHeight,
      width: chartWidth,
      zIndex: Footer_1.DEFAULT_FOOTER_Z_INDEX + 1
    },
    className: styles_module_css_1.default['line-chart-svg'],
    onMouseMove: (0, lodash_1.throttle)(event => {
      if (event.currentTarget) {
        const {
          top,
          left
        } = event.currentTarget.getBoundingClientRect();
        if (lastTouchPoint === undefined) {
          if (hoveredLabel === undefined) {
            onMouseOverTooltip(event, top, left, delaunays);
          }
        } else {
          setlastTouchPoint(onMouseOverTooltip(event, top, left, delaunays, lastTouchPoint));
        }
        setScrubbingLinePoints(event);
      }
    }, constants_1.DEFAULT_THROTTLING_INTERVAL),
    onMouseLeave: () => {
      clearScrubbingLinePoints();
    },
    onClick: event => {
      if (lastTouchPoint === undefined) {
        setLineFromSVG(event, delaunays);
      }
    },
    onTouchStart: event => {
      updateScrubLineId(event, delaunays);
      if (lastTouchPoint === undefined) {
        setlastTouchPoint(null);
      }
      setScrubbing(null);
      setScrubStartPoint(event.touches[0]);
      setScrubbingLinePoints(event);
    },
    onTouchEnd: () => {
      setScrubbing(false);
      moveTooltip();
      clearScrubbingLinePoints();
    }
  }, lodash_1.default.includes(optsXAxis.displayTicks, 'bottom') && react_1.default.createElement(Axis_1.default, {
    position: Axis_1.AXIS_POSITIONS.bottom,
    chartWidth: chartWidth,
    chartHeight: chartHeight,
    fontSize: optsXAxis.fontSize,
    textColor: (0, colors_1.parseColor)(optsXAxis.textColor, optsXAxis.textColor),
    ticks: xTicks.map(tick => ({
      data: tick,
      point: xScale(tick)
    })),
    formatter: optsXAxis.labelFormatter ? optsXAxis.labelFormatter : xAxisFormat,
    transitionDuration: transitionDuration
  }), lodash_1.default.includes(optsXAxis.displayTicks, 'top') && react_1.default.createElement(Axis_1.default, {
    position: Axis_1.AXIS_POSITIONS.top,
    chartWidth: chartWidth,
    chartHeight: chartHeight,
    fontSize: optsXAxis.fontSize,
    textColor: (0, colors_1.parseColor)(optsXAxis.textColor, optsXAxis.textColor),
    ticks: xTicks.map(tick => ({
      data: tick,
      point: xScale(tick)
    })),
    formatter: optsXAxis.labelFormatter ? optsXAxis.labelFormatter : xAxisFormat,
    transitionDuration: transitionDuration
  }), optsGridLine.showVerticalLines && react_1.default.createElement(Gridlines_1.default, {
    orientation: Gridlines_1.AXIS_ORIENTATIONS.vertical,
    range: yScale.range(),
    strokeWidth: 1,
    gridColor: (0, colors_1.parseColor)(optsGridLine.color, optsGridLine.color),
    ticks: xTicks.map(tick => ({
      point: xScale(tick),
      strokeWidth: 1,
      strokeCap: 'square',
      strokeStyle: optsGridLine.style || 'solid'
    })),
    transitionDuration: transitionDuration
  }), lodash_1.default.includes(optsYAxis.displayTicks, 'left') && react_1.default.createElement(Axis_1.default, {
    position: Axis_1.AXIS_POSITIONS.left,
    chartWidth: chartWidth,
    chartHeight: chartHeight,
    fontSize: optsYAxis.fontSize,
    textColor: (0, colors_1.parseColor)(optsYAxis.textColor, optsYAxis.textColor),
    ticks: yTicks.map(tick => ({
      data: tick,
      point: yScale(tick)
    })),
    formatter: optsYAxis.labelFormatter ? optsYAxis.labelFormatter : yAxisFormat,
    transitionDuration: transitionDuration
  }), lodash_1.default.includes(optsYAxis.displayTicks, 'right') && react_1.default.createElement(Axis_1.default, {
    position: Axis_1.AXIS_POSITIONS.right,
    chartWidth: chartWidth,
    chartHeight: chartHeight,
    fontSize: optsYAxis.fontSize,
    textColor: (0, colors_1.parseColor)(optsYAxis.textColor, optsYAxis.textColor),
    ticks: yTicks.map(tick => ({
      data: tick,
      point: yScale(tick)
    })),
    formatter: optsYAxis.labelFormatter ? optsYAxis.labelFormatter : yAxisFormat,
    transitionDuration: transitionDuration
  }), optsGridLine.showHorizontalLines && react_1.default.createElement(Gridlines_1.default, {
    orientation: Gridlines_1.AXIS_ORIENTATIONS.horizontal,
    range: xScale.range(),
    strokeWidth: 1,
    gridColor: (0, colors_1.parseColor)(optsGridLine.color, optsGridLine.color),
    ticks: yTicks.map(tick => ({
      point: yScale(tick),
      strokeWidth: darkenZeroLine && tick === 0 ? 3 : 1,
      strokeCap: 'square',
      strokeStyle: optsGridLine.style || 'solid'
    })),
    transitionDuration: transitionDuration
  }), shouldFill && react_1.default.createElement(FilledAreaLine_1.default, {
    line: contrainedFirstLine,
    color: currentLines.current[0].color,
    xMin: lodash_1.default.min(filteredFirstLineData.map(_ref15 => {
      let {
        x
      } = _ref15;
      return xScale(x);
    })),
    xMax: lodash_1.default.max(filteredFirstLineData.map(_ref16 => {
      let {
        x
      } = _ref16;
      return xScale(x);
    })),
    yMin: lodash_1.default.min(filteredFirstLineData.filter(_ref17 => {
      let {
        y
      } = _ref17;
      return Number.isFinite(y);
    }).map(_ref18 => {
      let {
        y
      } = _ref18;
      return yScale(y);
    })),
    yMax: lodash_1.default.max(filteredFirstLineData.filter(_ref19 => {
      let {
        y
      } = _ref19;
      return Number.isFinite(y);
    }).map(_ref20 => {
      let {
        y
      } = _ref20;
      return yScale(y);
    })),
    yZero: yTicks.includes(0) ? yScale(0) : lodash_1.default.max(filteredFirstLineData.filter(_ref21 => {
      let {
        y
      } = _ref21;
      return Number.isFinite(y);
    }).map(_ref22 => {
      let {
        y
      } = _ref22;
      return yScale(y);
    })),
    transitionDuration: transitionDuration
  }), react_1.default.createElement(Lines_1.default, {
    lines: currentLines.current.map(line => lodash_1.default.pick(line, ['cap', 'clipPath', 'color', 'cursor', 'durationMultiplier', 'endMarker', 'id', 'line', 'opacity', 'style', 'weight'])),
    transitionDuration: transitionDuration,
    onMouseOver: lineMouseOver,
    onMouseMove: lineMouseMove,
    onMouseOut: lineMouseOut,
    onClick: lineMouseClick
  }), verticalScrubberPoint.current && react_1.default.createElement(Gridlines_1.default, {
    orientation: Gridlines_1.AXIS_ORIENTATIONS.vertical,
    range: yScale.range(),
    gridColor: (0, colors_1.parseColor)(optsGridLine.scrubberColor, optsGridLine.scrubberColor),
    ticks: [{
      point: verticalScrubberPoint.current,
      strokeCap: 'square',
      strokeStyle: 'dash',
      strokeWidth: 2
    }],
    transitionDuration: 0
  }), horizontalScrubberPoint.current && react_1.default.createElement(Gridlines_1.default, {
    orientation: Gridlines_1.AXIS_ORIENTATIONS.horizontal,
    range: xScale.range(),
    gridColor: (0, colors_1.parseColor)(optsGridLine.scrubberColor, optsGridLine.scrubberColor),
    ticks: [{
      point: horizontalScrubberPoint.current,
      strokeCap: 'square',
      strokeStyle: 'dash',
      strokeWidth: 2
    }],
    transitionDuration: 0
  }), showLabels && react_1.default.createElement(LabelContainer_1.default, {
    labels: scaledLabels,
    onClick: (event, i) => {
      setLine(event, i);
      event.stopPropagation();
    },
    onMouseOver: (event, i) => {
      if (lastTouchPoint === undefined) {
        setTooltipToLineEnd(event, i);
      }
      setHoveredLabel(lineData[i] ? lineData[i].id : undefined);
    },
    onMouseMove: event => {
      event.stopPropagation();
    },
    onMouseOut: () => {
      setHoveredLabel(undefined);
    },
    transitionDuration: transitionDuration
  }), annotationData.length > 0 && react_1.default.createElement(Annotation_1.default, {
    data: scaledAnnotations,
    transitionDuration: transitionDuration
  }), (optsTooltip.show !== false || optsTooltip.showMarker !== false) && tooltip.value !== null && react_1.default.createElement("circle", {
    className: "tooltip-marker",
    cx: tooltip.position.x,
    cy: tooltip.dotY,
    r: tooltip.dotWeight,
    fill: tooltip.color,
    pointerEvents: "none"
  }))), optsTooltip.show !== false && tooltip.value !== null && react_1.default.createElement("div", {
    className: styles_module_css_1.default['tooltip-container']
  }, react_1.default.createElement(Tooltip_1.default, {
    direction: tooltip.direction,
    x: tooltip.position.x,
    y: tooltip.position.y,
    width: chartWidth
  }, react_1.default.createElement(TooltipContent_1.default, {
    title: tooltip.title,
    subtitle: optsTooltip.showSubtitle ? tooltip.xLabel : null,
    value: tooltip.value,
    units: optsTooltip.units,
    color: optsTooltip.color || tooltip.color,
    annotation: tooltip.annotation,
    decimals: optsTooltip.decimals,
    type: tooltip.type
  }))));
});
InnerContent.propTypes = {
  /**
   * Height of inner content.
   */
  chartHeight: prop_types_1.number,
  /**
   * Width of inner content
   */
  chartWidth: prop_types_1.number.isRequired,
  /**
   * Gridline options.
   */
  optsGridLine: (0, prop_types_1.shape)({
    showVerticalLines: prop_types_1.bool.isRequired,
    showHorizontalLines: prop_types_1.bool.isRequired,
    color: prop_types_1.string
  }).isRequired,
  /**
   * Label options.
   */
  optsLabel: (0, prop_types_1.shape)({
    show: prop_types_1.bool,
    width: prop_types_1.number
  }).isRequired,
  /**
   * X axis options.
   */
  optsXAxis: (0, prop_types_1.shape)({
    displayTicks: (0, prop_types_1.arrayOf)(prop_types_1.string).isRequired,
    fontSize: prop_types_1.number.isRequired,
    textColor: prop_types_1.string,
    labelFormatter: prop_types_1.func
  }).isRequired,
  /**
   * Y axis options.
   */
  optsYAxis: (0, prop_types_1.shape)({
    displayTicks: (0, prop_types_1.arrayOf)(prop_types_1.string).isRequired,
    fontSize: prop_types_1.number.isRequired,
    textColor: prop_types_1.string,
    labelFormatter: prop_types_1.func
  }).isRequired,
  /**
   * Tooltip options.
   */
  optsTooltip: (0, prop_types_1.shape)({
    show: prop_types_1.bool.isRequired,
    showSubtitle: prop_types_1.bool.isRequired,
    decimals: prop_types_1.number
  }).isRequired,
  /**
   * Data for the chart.
   * @param datasets Data entries.
   * Each entry contains required params id, name, x_type, y_type and a data array
   * with key/value pairs.
   * Optional params of footnote, sources array and meta array
   * @param sources Data sources in the standard format. (see chartSources for structure)
   */
  data: (0, prop_types_1.oneOfType)([(0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.dataShape)), (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    datasets: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.dataShape)),
    sources: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.sourcesShape))
  }))]).isRequired,
  /**
   * Formatted data for each line.
   */
  lineData: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    color: prop_types_1.string.isRequired,
    customDomain: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOfType)([prop_types_1.default.instanceOf(Date), prop_types_1.number])).isRequired,
    data: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
      x: (0, prop_types_1.oneOfType)([prop_types_1.default.instanceOf(Date), prop_types_1.number]).isRequired,
      y: prop_types_1.number.isRequired,
      key: prop_types_1.string.isRequired
    })).isRequired,
    fontSize: prop_types_1.number.isRequired,
    id: prop_types_1.string.isRequired,
    labelText: prop_types_1.string,
    lineStyle: prop_types_1.string.isRequired,
    lineWeight: prop_types_1.number.isRequired,
    name: prop_types_1.string.isRequired,
    tooltipTitle: prop_types_1.string
  })).isRequired,
  /**
   * Formatted annotation data.
   */
  annotationData: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    color: prop_types_1.string,
    fontSize: prop_types_1.number,
    key: prop_types_1.string,
    lineID: prop_types_1.string,
    radius: prop_types_1.number,
    showTitleOnChart: prop_types_1.bool,
    text: prop_types_1.string,
    title: prop_types_1.string,
    x: (0, prop_types_1.oneOfType)([prop_types_1.default.instanceOf(Date), prop_types_1.number]).isRequired,
    y: prop_types_1.number.isRequired
  })),
  /**
   * Defines which group and category each data belongs to. Allows override of name and color.
   * @param id metric id
   * @param color {string} color of dot 1, overrides dotOptions
   * @param lineWeight {number} weight of line
   * @param lineStyle {string} style of line, 'solid', 'dot', or 'dash'
   * @param labelText {string} label text override
   * @param tooltipTitle {string} tooltip title override
   * @param annotations {object[]} annotation objects for data series
   * @param annotations[].color {string} color of annotation text
   * @param annotations[].fontSize {number} fontSize of annotation text
   * @param annotations[].key {string} key of annotation, matches data key value in data raay
   * @param annotations[].position {string} where should the annotation be show relative to line, 'above' or 'below'
   * @param annotations[].showTitleOnChart {bool} should annotation be shown on chart
   * @param annotations[].text {string} text of annotation
   * @param annotations[].title {string} title of annotation
   */
  dataSeriesOptions: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    color: prop_types_1.string,
    endMarker: prop_types_1.bool,
    id: prop_types_1.string.isRequired,
    labelText: prop_types_1.string,
    lineStyle: (0, prop_types_1.oneOf)(['solid', 'dot', 'dash']),
    lineWeight: prop_types_1.number,
    markerColor: (0, prop_types_1.oneOfType)([prop_types_1.string, (0, prop_types_1.arrayOf)(prop_types_1.string)]),
    markerWeight: prop_types_1.number,
    tooltipTitle: prop_types_1.string,
    annotations: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
      color: prop_types_1.string,
      fontSize: prop_types_1.number,
      key: prop_types_1.string.isRequired,
      position: (0, prop_types_1.oneOf)(['above', 'below']),
      showTitleOnChart: prop_types_1.bool,
      text: prop_types_1.string,
      title: prop_types_1.string
    }))
  })),
  /**
   * Ticks for the X axis.
   */
  xTicks: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOfType)([prop_types_1.default.instanceOf(Date), prop_types_1.number])).isRequired,
  /**
   * Ticks for the Y axis.
   */
  yTicks: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOfType)([prop_types_1.default.instanceOf(Date), prop_types_1.number])).isRequired,
  /**
   * X axis unit type.
   */
  xType: prop_types_1.string.isRequired,
  /**
   * yAxis unit type.
   */
  yType: prop_types_1.string.isRequired,
  /**
   * Scale for the X axis
   */
  xScale: prop_types_1.func.isRequired,
  /**
   * Scale for the Y axis
   */
  yScale: prop_types_1.func.isRequired,
  /**
   * Hovered line Id state passthrough.
   */
  hoveredLabel: prop_types_1.string,
  /**
   * hoveredLabel state setter.
   */
  setHoveredLabel: prop_types_1.func.isRequired,
  /**
   * Selected line Id state passthrough.
   */
  selectedLines: (0, prop_types_1.oneOfType)([(0, prop_types_1.arrayOf)(prop_types_1.string), prop_types_1.string]).isRequired,
  /**
   * selectedLines state setter.
   */
  setLine: prop_types_1.func.isRequired,
  /**
   * User touch point state passthrough.
   */
  lastTouchPoint: prop_types_1.string,
  /**
   * lastTouchPoint state setter.
   */
  setlastTouchPoint: prop_types_1.func.isRequired,
  /**
   * User scrub point state passthrough.
   */
  scrubStartPoint: prop_types_1.string,
  /**
   * scrubStartPoint state setter.
   */
  setScrubStartPoint: prop_types_1.func.isRequired,
  /**
   * Tooltip for the chart.
   */
  tooltip: (0, prop_types_1.shape)({
    color: prop_types_1.string,
    direction: prop_types_1.string,
    dotWeight: prop_types_1.number,
    dotY: prop_types_1.number,
    position: (0, prop_types_1.shape)({
      x: prop_types_1.number,
      y: prop_types_1.number
    }),
    title: prop_types_1.string,
    value: prop_types_1.number,
    xLabel: prop_types_1.string
  }).isRequired,
  /**
   * General tooltip setter method
   */
  moveTooltip: prop_types_1.func.isRequired,
  /** On line mouse over event (event, dataIndex, data { key, formatted, value }) */
  onClickLine: prop_types_1.func,
  /** On line mouse out event (event, dataIndex, data ) */
  onMouseOutLine: prop_types_1.func,
  /** On line click event (event, data { key, formatted, value }) */
  onMouseOverLine: prop_types_1.func,
  /**
   * Tooltip mouseMove setter method.
   */
  onMouseOverTooltip: prop_types_1.func.isRequired,
  /**
   * Tooltip setter for label hover.
   */
  setTooltipToLineEnd: prop_types_1.func.isRequired,
  /**
   * Sets if filledAreaLine should be used.
   */
  fillToOrigin: prop_types_1.bool.isRequired,
  /**
   * Dsiplayed xDomain for the chart.
   */
  refittedXdomain: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOfType)([prop_types_1.number, prop_types_1.string])).isRequired,
  /**
   * length of transitions in ms.
   */
  transitionDuration: prop_types_1.number,
  /** Determine if chart should render as spark */
  isSpark: prop_types_1.bool.isRequired
};
exports.default = InnerContent;